export const awsExports = {
    "REGION" : "us-east-1",
    "USER_POOL_ID": "us-east-1_Cnd8SADeW",
    "USER_POOL_APP_CLIENT_ID": "8mp8a1sj6u7c4copcnqdr5n34"
}